import { useMemo } from "react";
import useAuthStore from "../../../stores/authStore";

export const useUserRole = () => {
  const { computedUser, user: tokenUser } = useAuthStore();

  const effectiveUser = computedUser || tokenUser;
  const userRoles = useMemo(() => effectiveUser?.roles || [], [effectiveUser]);

  const isSuperAdmin = useMemo(() => {
    return (
      Array.isArray(userRoles) &&
      userRoles.length === 1 &&
      userRoles[0] === "ROLE_SUPER_ADMIN"
    );
  }, [userRoles]);
  const hasRole = (role) => {
    return Array.isArray(userRoles) && userRoles.includes(role);
  };

  return {
    user: effectiveUser,
    userRoles,
    isSuperAdmin,
    hasRole,
  };
};

export default useUserRole;
